import { Link } from "react-router-dom";

const TOKEN = /(https?:\/\/[^\s)]+|[\w.+-]+@[\w-]+\.[\w.]+|\/(?:register|login|contact|privacy|terms|app\/[\w/-]+))/g;
const cls = "font-semibold text-violet-700 underline underline-offset-2 hover:text-violet-900";

export const linkify = (text, keyPrefix = "") =>
  text.split(TOKEN).map((part, i) => {
    const key = `${keyPrefix}-${i}`;
    if (/^https?:\/\//.test(part)) return <a key={key} href={part} target="_blank" rel="noreferrer" className={cls}>{part}</a>;
    if (/^[\w.+-]+@[\w-]+\.[\w.]+$/.test(part)) return <a key={key} href={`mailto:${part.replace(/\.$/, "")}`} className={cls}>{part}</a>;
    if (/^\/(register|login|contact|privacy|terms|app\/)/.test(part)) return <Link key={key} to={part} className={cls}>{part}</Link>;
    return part;
  });
